import { differenceInCalendarDays, isValid } from 'date-fns';

// SEAR-704: the muki image-generator hint is withheld from B2C mU Pro/mU 360
// users through their first 30 days since signup (day 0–29), then becomes
// eligible. This primitive itself is hint-agnostic.
export const NEW_USER_WINDOW_DAYS = 30;

/**
 * Whether `createdAtMs` falls within the first `days` calendar days of signup
 * (day 0..days-1). Mirrors `withdrawalEligibility.ts`'s `isWithinWindowDays`.
 *
 * `createdAtMs` is epoch **milliseconds**, sourced from `user.createdAt`
 * (`me.created.timestamp` — a deprecated SDK field, but the only signup date we
 * have). Returns `false` on a nullish / non-finite / invalid timestamp, i.e.
 * **fail open**: a data gap treats the user as not-new so the hint still shows.
 */
export const isWithinDaysOfSignup = (
  createdAtMs: number | undefined,
  days = NEW_USER_WINDOW_DAYS,
  now: Date = new Date(),
): boolean => {
  if (createdAtMs == null || !Number.isFinite(createdAtMs)) return false;
  const signup = new Date(createdAtMs);
  if (!isValid(signup)) return false;
  const diff = differenceInCalendarDays(now, signup);
  return diff >= 0 && diff < days;
};
